import * as React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

interface Props {
  message: string;
}

export default function InfoButton({ message }: Props) {

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {message}
    </Tooltip>
  );

  return (
    <OverlayTrigger
      placement="right"
      delay={{ show: 250, hide: 400 }}
      overlay={renderTooltip}
    >
      <Button variant="light" size="sm" className="ms-1">
        <i className="fa fa-info" />
      </Button>
    </OverlayTrigger>
  );
}
